module.exports = "data:application/octet-stream;base64,cHJhZ21hIHNvbGlkaXR5IF4wLjQuMjQ7Cgpjb250cmFjdCBNb3JnYW5TdGFyayB7CiAgYWRkcmVzcyBvd25lcjsKICB1aW50MjU2IHB1YmxpYyBiYWxhbmNlOwoKICBjb25zdHJ1Y3RvcigpIHB1YmxpYyBwYXlhYmxlIHsKICAgIHJlcXVpcmUobXNnLnZhbHVlID09IDApOwogICAgb3duZXIgPSBtc2cuc2VuZGVyOwogIH0KCiAgZnVuY3Rpb24gY29sbGVnZUZ1bmQoKSBwdWJsaWMgcGF5YWJsZSB7CiAgICByZXF1aXJlKG1zZy5zZW5kZXIgPT0gb3duZXIpOwogICAgYmFsYW5jZSArPSBtc2cudmFsdWU7CiAgfQoKICBmdW5jdGlvbiBjaGVja0JhbGFuY2UoKSBwdWJsaWMgdmlldyByZXR1cm5zICh1aW50MjU2KSB7CiAgICByZXR1cm4gYWRkcmVzcyh0aGlzKS5iYWxhbmNlOwogIH0KfQo="


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/MorganStark.sol
// module id = 1338
// module chunks = 0